import React, { useEffect, useState } from 'react';
import {
  InteractiveButtons,
  LandingPageContainer,
  MiscellaneousButtons,
  HeaderContainer,
  MainTitle,
  SubTitle,
  ButtonsContainer,
  MiscellaneousButtonsContainer,
  VersionContainer,
  VersionText,
  ButtonIcon,
  CocacolaTagImage,
  TagImageBackground,
  InterativeBtnText,
  UserInfoText,
  CircleDot,
  LogoutButtons,
  UserInfoContainer,
} from './LandingPage.Styled';
import {
  DataUpdate,
  ExistingResults,
  Guide,
  LogoutIcon,
  RGMPlayground,
  TagBackground,
} from '../../assets/images/landing-screen';
import { useNavigate } from 'react-router-dom';
import { CocacolaTag } from '../../assets/images';
import { useSelector } from 'react-redux';
import { fetchUserGuideVideo, fetchUserLoginDetails, selectAuthUsername } from '../../features/auth/authSlice';
import { clearMsalTokens, formatCustomDate, getCookie, getTodayDate, truncateName } from '../../utils/helper';
import { resetInputKpiState } from '../../features/inputKpi/inputKpiSlice';
import {
  resetReviewTable,
  toggleEnableReviewTableBtn,
  toggleEnableReviewTableDialog,
} from '../ScenarioCreation/components/ReviewTable/reviewTableSlice';
import { resetPerformanceTableState } from '../../features/performanceTable/performanceTableSlice';
import { resetScenarioName, setScenarioAction } from '../../features/scenarioCreation/scenarioCreationSlice';
import { useAppDispatch, useAppSelector } from '../../state/hooks';
import { resetForm } from '../../components/FormComponent/formSlice';
import SharePointDialog from '../../components/UI/SharePointDialog';
import { RootState } from '../../state/store';
import { API_ENDPOINTS } from '../../services/ApiConfig';
import { CONSTANTS } from '../../utils/constant';
import UserGuideDialog from './components/UserGuideDialog';
import { resetFilters, setComingFromScreen } from '../../features/scenarioLibrary/scenarioLibrarySlice';
import { Skeleton } from '@mui/material';

const LandingPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [openGuideDialog, setOpenGuideDialog] = useState<boolean>(false);
  const { loginDetails, videoURL, videoURLError, videoURLoader } = useAppSelector((state: RootState) => state.auth);

  useEffect(() => {
    const payload = {
      name: getCookie('username'),
      last_login_activity: new Date(),
    };
    dispatch(fetchUserLoginDetails(payload));
  }, []);

  const rgmPlayground = async () => {
    await dispatch(resetScenarioName());
    await dispatch(resetPerformanceTableState());
    await dispatch(resetInputKpiState());
    await dispatch(toggleEnableReviewTableBtn(false));
    await dispatch(toggleEnableReviewTableDialog(false));
    await dispatch(resetReviewTable());
    await dispatch(setScenarioAction('new'));
    await dispatch(resetForm());
    navigate(`/${CONSTANTS.PATH.SCENARIOCREATION}`);
  };

  const viewExistingOutput = () => {
    dispatch(setComingFromScreen('landingPage'));
    dispatch(resetFilters());
    navigate(`/${CONSTANTS.PATH.SCENARIOLIBRARY}`);
  };

  const dataUpdate = () => {
    setOpenDialog(true);
  };

  const guideOutput = () => {
    const payload = { video_name: 'sample_video.mp4' };
    dispatch(fetchUserGuideVideo(payload));
    setOpenGuideDialog(true);
  };

  const handleLogout = () => {
    clearMsalTokens();
    navigate(`/${CONSTANTS.PATH.LOGIN}`);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleCloseGuideDialog = () => {
    setOpenGuideDialog(false);
  };

  const handleConfirm = () => {
    window.open(API_ENDPOINTS.SHAREPOINT_URL, '_blank');
  };

  const username = useSelector(selectAuthUsername);
  const url = videoURL.video_url;

  return (
    <LandingPageContainer>
      <CocacolaTagImage src={CocacolaTag} alt="Logo" />
      <TagImageBackground src={TagBackground} alt="Logo" />
      <HeaderContainer>
        <MainTitle>{CONSTANTS.HEADER_LABEL}</MainTitle>
        <SubTitle>{CONSTANTS.DASHBOARD_INFO}</SubTitle>
      </HeaderContainer>
      <ButtonsContainer>
        <UserInfoContainer>
          <UserInfoText sx={{ mr: '4px' }}>
            {username == null ? getCookie('username') : truncateName(username, 20)}{' '}
          </UserInfoText>
          {loginDetails === null ? (
            <>
              {' '}
              | Last Login: <Skeleton style={{ marginLeft: '10px' }} variant="rectangular" width={80} height={15.34} />
            </>
          ) : (
            <UserInfoText> | Last Login: {formatCustomDate(new Date(loginDetails?.last_login_activity))}</UserInfoText>
          )}
          <CircleDot />
          {loginDetails === null ? (
            <>
              {' '}
              | Last Data Refresh:{' '}
              <Skeleton style={{ marginLeft: '10px' }} variant="rectangular" width={80} height={15.34} />
            </>
          ) : (
            <UserInfoText>Last Data Refresh: {formatCustomDate(new Date(loginDetails?.last_updated))}</UserInfoText>
          )}
        </UserInfoContainer>
        <InteractiveButtons onClick={rgmPlayground}>
          <ButtonIcon src={RGMPlayground} alt="RGM Playground" />
          <InterativeBtnText>Create New Scenario</InterativeBtnText>
        </InteractiveButtons>
        <InteractiveButtons style={{ marginTop: '4%' }} onClick={viewExistingOutput}>
          <ButtonIcon src={ExistingResults} alt="Existing Results" />
          <InterativeBtnText>View Saved Results</InterativeBtnText>
        </InteractiveButtons>
        <MiscellaneousButtonsContainer>
          <MiscellaneousButtons onClick={dataUpdate}>
            <ButtonIcon src={DataUpdate} alt="Data Update" />
            Data Update
          </MiscellaneousButtons>
          <MiscellaneousButtons sx={{ ml: '4%' }} onClick={guideOutput}>
            <ButtonIcon src={Guide} alt="Guide" />
            Guide
          </MiscellaneousButtons>
        </MiscellaneousButtonsContainer>
      </ButtonsContainer>
      <LogoutButtons onClick={handleLogout}>
        <ButtonIcon src={LogoutIcon} alt="Guide" />
        Logout
      </LogoutButtons>
      <VersionContainer>
        <VersionText>Version {CONSTANTS.TOOL_VERSION}</VersionText>
      </VersionContainer>
      <SharePointDialog open={openDialog} onClose={handleCloseDialog} onConfirm={handleConfirm} />
      <UserGuideDialog
        open={openGuideDialog}
        onClose={handleCloseGuideDialog}
        videoUrl={url}
        loading={videoURLoader}
        error={videoURLError}
      />
    </LandingPageContainer>
  );
};

export default LandingPage;
